import pedidoComissoesAdvogado from './pedidoComissoesAdvogado/config';
import pedidoComissoesEstagiario from './pedidoComissoesEstagiario/config';

export const pedido_comissoes_advogado = pedidoComissoesAdvogado;
export const pedido_comissoes_estagiario = pedidoComissoesEstagiario;
